import { Link } from 'react-router-dom';
import { CornerTicks } from '@/components/marketing/site/hud';
import { scrollToDocsSection } from '@/lib/docs-content';

export function DocsPanel({
  children,
  className = '',
  ticks = 'border-accent/40',
}: {
  children: React.ReactNode;
  className?: string;
  ticks?: string;
}) {
  return (
    <div className={`notch border-line bg-surface/20 relative border ${className}`}>
      <CornerTicks className={ticks} size={6} offset={5} />
      {children}
    </div>
  );
}

export function DocsCard({
  children,
  className = '',
  href,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}) {
  const classes = `docs-card notch-sm border-line bg-surface/25 group relative block border p-5 transition-colors ${className}`;

  if (href?.includes('#')) {
    return (
      <a
        href={href}
        onClick={(event) => {
          event.preventDefault();
          const id = href.split('#')[1];
          if (id) scrollToDocsSection(id);
          onClick?.();
        }}
        className={classes}
      >
        <CornerTicks className="border-accent/35 group-hover:border-accent/70" size={5} offset={4} />
        {children}
      </a>
    );
  }

  if (href) {
    return (
      <Link to={href} onClick={onClick} className={classes}>
        <CornerTicks className="border-accent/35 group-hover:border-accent/70" size={5} offset={4} />
        {children}
      </Link>
    );
  }

  return (
    <div className={classes}>
      <CornerTicks className="border-accent/35" size={5} offset={4} />
      {children}
    </div>
  );
}
